module.exports = __webpack_public_path__ + "img/zhuo_logo.6eee92e9.png";